import React from 'react';
import { Timeline } from 'antd';
import {
  UserAddOutlined, DeleteOutlined, LoadingOutlined, UndoOutlined,
  BranchesOutlined, DislikeOutlined, CheckSquareOutlined, EditOutlined,
  SoundOutlined, SisternodeOutlined,
} from '@ant-design/icons';
import { statusType } from './utils';

// Компонент для отображения элементов истории талона
function DescriptionItem({ title, content, type }) {
  return (
    <div style={{ display: 'flex', flexDirection: type }}>
      <p style={{ fontWeight: 'bold', margin: type === 'row' ? '0 8px 0 0' : '0', minWidth: '100px' }}>
        {title}
        :
      </p>
      {content}
    </div>
  );
}

function TicketHistory({ historyData }) {
  // Функции для отображения истории талона
  const getDot = (status) => {
    switch (status) {
      case '0':
        return <UserAddOutlined style={{ fontSize: '24px' }} />;
      case '1':
        return <SoundOutlined style={{ fontSize: '24px' }} />;
      case '2':
        return <EditOutlined style={{ fontSize: '24px' }} />;
      case '3':
        return <CheckSquareOutlined style={{ fontSize: '24px' }} />;
      case '4':
        return <DislikeOutlined style={{ fontSize: '24px' }} />;
      case '5':
        return <BranchesOutlined style={{ fontSize: '24px' }} />;
      case '6':
        return <LoadingOutlined style={{ fontSize: '24px' }} />;
      case '7':
        return <UndoOutlined style={{ fontSize: '24px' }} />;
      case '9':
        return <DeleteOutlined style={{ fontSize: '24px' }} />;
      case '10':
        return <SisternodeOutlined style={{ fontSize: '24px' }} />;
      case '69':
        return <DeleteOutlined style={{ fontSize: '24px', color: 'orange' }} />;
      default:
        return null;
    }
  };

  const getColor = (status) => {
    switch (status) {
      case '2':
      case '4':
        return 'grey';
      case '1':
      case '5':
      case '6':
      case '7':
      case '10':
        return 'blue';
      case '0':
      case '3':
        return 'green';
      case '9':
        return 'red';
      case '69':
        return 'orange';
      default:
        return 'grey';
    }
  };

  const renderTimeLineItems = () => historyData.map((el, index) => {
    const {
      status,
      close_data: closeData,
      operator_fio: operatorFio,
      queue_name: queueName,
      name,
      questiontext,
      row_id: rowId,
    } = el;
    return (
      <Timeline.Item
        key={`history-item-${rowId || status}-${closeData}`}
        dot={getDot(status)}
        label={`${index + 1}. ${statusType[status] || `Неизвестный статус (${status})`}`}
        color={getColor(status)}
      >
        <DescriptionItem title="Дата и время" content={closeData} type="row" />
        {name && <DescriptionItem title="Рабочее место" content={name} type="row" />}
        {queueName && <DescriptionItem title="Очередь" content={queueName} type="row" />}
        {(operatorFio && operatorFio !== 'Система') && <DescriptionItem title="Оператор" content={operatorFio} type="row" />}
        {questiontext && <DescriptionItem title="Решенный вопрос" content={questiontext} type="column" />}
      </Timeline.Item>
    );
  });

  return (
    <Timeline mode="left">{renderTimeLineItems()}</Timeline>
  );
}

export default TicketHistory;
